// extracted by mini-css-extract-plugin
export var dropdown = "_vd-0";
export var imageWrapper = "_vd-3";
export var itemNameContainer = "_vd-1";
export var productImage = "_vd-2";
export var spinnerWrapper = "_vd-4";